import React from 'react';
import styled from 'styled-components';

import { colorSurfaceLow, mediaQueryDesktopMin } from '@/styleUtils';

export const Wrapper = styled(({ hide, sticky, ...props }) => (
  // eslint-disable-next-line react/jsx-filename-extension
  <section {...props} />
))`
  display: grid;
  grid-column: 1 / 3;
  z-index: 2;

  ${({ $hide }) => {
    if ($hide) {
      if ($hide === 'mobile') {
        return `
          display: none;
          
          @media ${mediaQueryDesktopMin} {
            display: block;
          }
        `;
      }

      return `
        @media ${mediaQueryDesktopMin} {
          display: none;
        }
      `;
    }

    return ``;
  }}

  ${({ $sticky }) => {
    if ($sticky) {
      return `
        position: sticky;
        top: 24px;
      `;
    }

    return '';
  }}
  
  & > div {
    &:empty {
      margin: 0;
    }
  }
`;

export const Block = styled.div`
  > div {
    background: ${colorSurfaceLow};
    padding: 16px 0;
    border-radius: 12px;

    ${({ $blockStyles }) => {
      if ($blockStyles.margin) {
        return `
          margin: ${$blockStyles.margin};
        `;
      }

      return ``;
    }}
  }
`;

export const WithoutWrapper = styled.div``;
